import React, { useState } from 'react';
import { Spinner, Switch, useGlobalContext } from 'seagull';
import { useStoreActions } from "../../../../../contexts";
import styles from "../BillingControl.module.scss";
export default function CreditSwitch(props) {
  const {
    chargeId,
    agreementId,
    isPaused,
    disabled,
    tooltipTitle,
    ['data-testid']: testid,
    onRefresh
  } = props;
  const [isResumed, setIsResumed] = useState(!isPaused);
  const [loading, setLoading] = useState(false);
  const globalContext = useGlobalContext();
  const {
    api
  } = useStoreActions();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.switch
  }, loading && /*#__PURE__*/React.createElement(Spinner, {
    size: 24
  }), /*#__PURE__*/React.createElement(Switch, {
    value: chargeId,
    checked: isResumed,
    disabled: disabled || loading,
    "data-testid": testid,
    tooltip: tooltipTitle ? {
      placement: 'top',
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": testid && "".concat(testid, "-tooltip")
      }, tooltipTitle)
    } : undefined,
    onChange: async e => {
      const {
        checked,
        value
      } = e.target;

      try {
        setLoading(true);

        if (checked) {
          await api.charge.resumeCredit(agreementId, value);
        } else {
          await api.charge.pauseCredit(agreementId, value);
        }

        await onRefresh({
          silent: true
        });
        setIsResumed(checked);
      } catch (error) {
        globalContext.showErrorToast("Failed to ".concat(checked ? 'resume' : 'pause', " credit"), 'pause-credit-error-toast');
      } finally {
        setLoading(false);
      }
    }
  }));
}